import { ExoticComponent } from "react";
import { NodeProps } from "reactflow";
import BaseNode from "../../../features/reactflow/nodes/base/BaseNode";
import { NodeType } from "../../../models/nodeType";
import AdditiveOperatorNode from "./AdditiveOperatorNode";
import AiDecisionNode from "./AiDecisionNode";
import AllegianceAndAmountNode from "./AllegianceAndAmountNode";
import AllegianceNode from "./AllegianceNode";
import StickyNode from "./base/StickyNode";
import SubgraphInputNode from "./base/SubgraphInputNode";
import SubgraphNode from "./base/SubgraphNode";
import BooleanNode from "./BooleanNode";
import BooleanOperatorNode from "./BooleanOperatorNode";
import CameraFollowNpcNode from "./CameraFollowNpcNode";
import CameraPanToLocationNode from "./CameraPanToLocationNode";
import CameraSnapToLocationNode from "./CameraSnapToLocationNode";
import ChangePointerPriorityNode from "./ChangePointerPriorityNode";
import ClearFeatureFlagNode from "./ClearFeatureFlagNode";
import DelayNode from "./DelayNode";
import ClearFlagNode from "./ClearFlagNode";
import CloseUIElementNode from "./CloseUIElementNode";
import CompareItemsNode from "./CompareItemsNode";
import CompleteQuestLogNode from "./CompleteQuestLogNode";
import CompleteQuestNode from "./CompleteQuestNode";
import CompleteQuestTaskNode from "./CompleteQuestTaskNode";
import ConditionExperimentNode from "./ConditionExperimentNode";
import CoordinatesNode from "./CoordinatesNode";
import CraftingStationNode from "./CraftingStationNode";
import CreateQuestLogNode from "./CreateQuestLogNode";
import CreateQuestTaskNode from "./CreateQuestTaskNode";
import CustomItemNode from "./CustomItemNode";
import DialogNode from "./DialogNode";
import DoorNode from "./DoorNode";
import DynamicItemNameAndQuantityNode from "./DynamicItemNameAndQuantityNode";
import DynamicLocationNode from "./DynamicLocationNode";
import DynamicNpcNode from "./DynamicNpcNode";
import EndNode from "./EndNode";
import EnergyRewardNode from "./EnergyRewardNode";
import FeatureFlagNode from "./FeatureFlagNode";
import FlagNode from "./FlagNode";
import FlowNode from "./FlowNode";
import GiveItemNode from "./GiveItemNode";
import GrantRewardNode from "./GrantRewardNode";
import HideEmoteOnNpcNode from "./HideEmoteOnNpcNode";
import HighlightUIElementNode from "./HighlightUIElementNode";
import ItemNameAndQuantityNode from "./ItemNameAndQuantityNode";
import JoinNode from "./JoinNode";
import LocationNode from "./LocationNode";
import LootTableRewardNode from "./LootTableRewardNode";
import MapEntityNode from "./MapEntityNode";
import ModifyPlayerAllegianceNode from "./ModifyPlayerAllegianceNode";
import RelationshipCheckNode from "./RelationshipCheckNode";
import ModNode from "./ModNode";
import MultiplicativeOperatorNode from "./MultiplicativeOperatorNode";
import NpcFaceNpcNode from "./NpcFaceNpcNode";
import NpcFacePlayerNode from "./NpcFacePlayerNode";
import NpcMoveByXYNode from "./NpcMoveByXYNode";
import NpcMoveToLocationNode from "./NpcMoveToLocationNode";
import NpcMoveToNpcNode from "./NpcMoveToNpcNode";
import NpcMoveToPlayerNode from "./NpcMoveToPlayerNode";
import NpcWanderingModeStartNode from "./NpcWanderingModeStartNode";
import NpcWanderingModeStopNode from "./NpcWanderingModeStopNode";
import NpcNode from "./NpcNode";
import NpcSetDirectionNode from "./NpcSetDirectionNode";
import NpcSetSpriteNode from "./NpcSetSpriteNode";
import NpcUnequipEquipmentNode from "./NpcUnequipEquipmentNode";
import NumberNode from "./NumberNode";
import OpenUIElementNode from "./OpenUIElementNode";
import OpenUrlNode from "./OpenUrlNode";
import PlayAmbienceNode from "./PlayAmbienceNode";
import PlayAmbiencePositionalNode from "./PlayAmbiencePositionalNode";
import PlayerActionCountNode from "./PlayerActionCountNode";
import PlayerCurrentSkillExperiencePointsNode from "./PlayerCurrentSkillExperiencePointsNode";
import PlayerCurrentSkillLevelNode from "./PlayerCurrentSkillLevelNode";
import PlayerGrantSkillExperiencePointsNode from "./PlayerGrantSkillExperiencePointsNode";
import PlayerGrantSkillLevelNode from "./PlayerGrantSkillLevelNode";
import PlayerHasCompletedQuestNode from "./PlayerHasCompletedQuestNode";
import PlayerHasEquipmentNode from "./PlayerHasEquipmentNode";
import PlayerHasItemInEquipmentSlotNode from "./PlayerHasItemInEquipmentSlotNode";
import PlayerHasStartedQuestNode from "./PlayerHasStartedQuestNode";
import PlayerMoveToLocationNode from "./PlayerMoveToLocationNode";
import PlayerMoveToNpcNode from "./PlayerMoveToNpcNode";
import PlayerUnequipEquipmentNode from "./PlayerUnequipEquipmentNode";
import PlaySfxNode from "./PlaySfxNode";
import PlaySfxPositionalNode from "./PlaySfxPositionalNode";
import PlayVideoNode from "./PlayVideoNode";
import PrefetchAmbienceNode from "./PrefetchAmbienceNode";
import PrefetchMusicNode from "./PrefetchMusicNode";
import PrefetchSfxNode from "./PrefetchSfxNode";
import RelationalOperatorNode from "./RelationalOperatorNode";
import RollChanceNode from "./RollChanceNode";
import ResetHighlightUIElementNode from "./ResetHighlightUIElementNode";
import RoomNode from "./RoomNode";
import SetFeatureFlagNode from "./SetFeatureFlagNode";
import SetFlagNode from "./SetFlagNode";
import SetFlagToValueNode from "./SetFlagToValueNode";
import SetLutNode from "./SetLutNode";
import SetMusicNode from "./SetMusicNode";
import SetNpcContextNode from "./SetNpcContextNode";
import ClearPopupTextOnNpcNode from "./ClearPopupTextOnNpcNode";
import SetPopupTextOnNpcNode from "./SetPopupTextOnNpcNode";
import ShowEmoteOnNpcNode from "./ShowEmoteOnNpcNode";
import ShowTasksNode from "./ShowTasksNode";
import ShowTutorialNode from "./ShowTutorialNode";
import SkillAndExperiencePointsNode from "./SkillAndExperiencePointsNode";
import SkillAndLevelsNode from "./SkillAndLevelsNode";
import SpawnEnemySequencerNode from "./SpawnEnemySequencerNode";
import SpawnEntityAtLocationNode from "./SpawnEntityAtLocationNode";
import SpawnEntityNode from "./SpawnEntityNode";
import SpawnObjectNode from "./SpawnObjectNode";
import SpawnSpriteEntityNode from "./SpawnSpriteEntityNode";
import SplitNode from "./SplitNode";
import StartByChattingToNpcNode from "./StartByChattingToNpcNode";
import StartByInteractingWithNpcNode from "./StartByInteractingWithNpcNode";
import StartCinematicNode from "./StartCinematicNode";
import StartDungeonNode from "./StartDungeonNode";
import StartExperimentNode from "./StartExperimentNode";
import StartIfPlayerAtLocationNode from "./StartIfPlayerAtLocationNode";
import StartNode from "./StartNode";
import StartWithNpcAtLocationNode from "./StartWithNpcAtLocationNode";
import StartWithSpriteObjectNode from "./StartWithSpriteObjectNode";
import SwitchNode from "./SwitchNode";
import TakeItemNode from "./TakeItemNode";
import VendorNode from "./VendorNode";
import WaitForChatWithNpcNode from "./WaitForChatWithNpcNode";
import WaitForEnemySequencerNode from "./WaitForEnemySequencerNode";
import WaitForEntityInteractionNode from "./WaitForEntityInteractionNode";
import WaitForNpcInteractionNode from "./WaitForNpcInteractionNode";
import WaitForPlayerLocationNode from "./WaitForPlayerLocationNode";
import WaitForTimeOfDayNode from "./WaitForTimeOfDayNode";
import WatchPlayerActionNode from "./WatchPlayerActionNode";
import StartTimerNode from "./StartTimerNode";

export const nodeTypes: Record<string, ExoticComponent<NodeProps<NodeType>>> = {
  StickyNode,
  BaseNode,
  SubgraphNode,
  SubgraphInputNode,
  FlowNode,
  LocationNode,
  DynamicItemNameAndQuantityNode,
  DynamicLocationNode,
  DynamicNpcNode,
  ItemNameAndQuantityNode,
  NpcNode,
  DialogNode,
  StartByChattingToNpcNode,
  StartByInteractingWithNpcNode,
  StartWithNpcAtLocationNode,
  StartIfPlayerAtLocationNode,
  SpawnEntityAtLocationNode,
  CreateQuestLogNode,
  CompleteQuestLogNode,
  CreateQuestTaskNode,
  CompleteQuestTaskNode,
  WaitForPlayerLocationNode,
  EndNode,
  SplitNode,
  JoinNode,
  StartNode,
  SwitchNode,
  BooleanNode,
  NumberNode,
  BooleanOperatorNode,
  RelationalOperatorNode,
  AdditiveOperatorNode,
  MultiplicativeOperatorNode,
  NpcMoveToNpcNode,
  NpcMoveToPlayerNode,
  NpcWanderingModeStartNode,
  NpcWanderingModeStopNode,
  NpcSetSpriteNode,
  PlayerCurrentSkillLevelNode,
  DoorNode,
  WaitForEntityInteractionNode,
  StartWithSpriteObjectNode,
  SpawnSpriteEntityNode,
  ShowTasksNode,
  OpenUIElementNode,
  CloseUIElementNode,
  HighlightUIElementNode,
  ResetHighlightUIElementNode,
  NpcMoveByXYNode,
  PlayerMoveToNpcNode,
  VendorNode,
  CraftingStationNode,
  SetFlagNode,
  SetFlagToValueNode,
  ClearFlagNode,
  FlagNode,
  PlayerHasStartedQuestNode,
  PlayerHasCompletedQuestNode,
  CameraFollowNpcNode,
  CameraPanToLocationNode,
  AllegianceNode,
  ModifyPlayerAllegianceNode,
  RelationshipCheckNode,
  AiDecisionNode,
  PlayerHasEquipmentNode,
  PlayerHasItemInEquipmentSlotNode,
  CompareItemsNode,
  WaitForNpcInteractionNode,
  WaitForChatWithNpcNode,
  CoordinatesNode,
  RoomNode,
  StartCinematicNode,
  ShowEmoteOnNpcNode,
  HideEmoteOnNpcNode,
  PrefetchMusicNode,
  SetMusicNode,
  SetNpcContextNode,
  SpawnEnemySequencerNode,
  WaitForEnemySequencerNode,
  PlayerGrantSkillExperiencePointsNode,
  PlayerGrantSkillLevelNode,
  PlayerCurrentSkillExperiencePointsNode,
  FeatureFlagNode,
  SetFeatureFlagNode,
  ClearFeatureFlagNode,
  CameraSnapToLocationNode,
  NpcSetDirectionNode,
  OpenUrlNode,
  WatchPlayerActionNode,
  PlayerActionCountNode,
  SpawnEntityNode,
  SpawnObjectNode,
  PlayerUnequipEquipmentNode,
  NpcUnequipEquipmentNode,
  PrefetchSfxNode,
  PlaySfxNode,
  PlaySfxPositionalNode,
  PrefetchAmbienceNode,
  PlayAmbienceNode,
  PlayAmbiencePositionalNode,
  NpcFaceNpcNode,
  NpcFacePlayerNode,
  AllegianceAndAmountNode,
  SkillAndExperiencePointsNode,
  SkillAndLevelsNode,
  ModNode,
  SetLutNode,
  CompleteQuestNode,
  ShowTutorialNode,
  TakeItemNode,
  GiveItemNode,
  NpcMoveToLocationNode,
  PlayerMoveToLocationNode,
  ChangePointerPriorityNode,
  MapEntityNode,
  CustomItemNode,
  EnergyRewardNode,
  LootTableRewardNode,
  GrantRewardNode,
  PlayVideoNode,
  WaitForTimeOfDayNode,
  StartTimerNode,
  StartDungeonNode,
  StartExperimentNode,
  ConditionExperimentNode,
  SetPopupTextOnNpcNode,
  ClearPopupTextOnNpcNode,
  RollChanceNode,
  DelayNode,
};

export const nodeTypeDictionary: Record<string, ExoticComponent<NodeProps<NodeType>>> = Object.fromEntries(
  Object.entries(nodeTypes).map(([nodeTypeName, nodeType]) => [nodeTypeName, nodeType])
);
